/**
 * Osprey "View Dashboard" appends ?fromOsprey=1 to the Lovebird redirect URL.
 * Persist before token exchange strips the query string (see SessionProvider).
 * Keep in sync with Osprey VIEW_DASHBOARD_FROM_OSPREY_QUERY_PARAMS.
 */
export const LOVEBIRD_FROM_OSPREY_SESSION_KEY = 'lovebirdFromOsprey';

const FROM_OSPREY_QUERY_PARAM = 'fromOsprey';
const FROM_OSPREY_QUERY_VALUE = '1';

export const persistOspreyTraditionalDashboardIntent = (
  searchParams: URLSearchParams
): void => {
  if (searchParams.get(FROM_OSPREY_QUERY_PARAM) === FROM_OSPREY_QUERY_VALUE) {
    sessionStorage.setItem(
      LOVEBIRD_FROM_OSPREY_SESSION_KEY,
      FROM_OSPREY_QUERY_VALUE
    );
  }
};

export const shouldUseTraditionalDashboardForPerchEnergy = (): boolean =>
  sessionStorage.getItem(LOVEBIRD_FROM_OSPREY_SESSION_KEY) ===
  FROM_OSPREY_QUERY_VALUE;
